module.exports = __webpack_public_path__ + "static/media/Hunter.59f7ce0c.png";